import { buildClinicConfig } from "../../clinicConfig/build.mjs";

//#region src/tenants/demo/clinic.ts
/**
* Demo clinic / payor maps passed into Libretto jobs.
*
* Mirrors Skylight's Arizona payors, plus BCBSTX for the canned Austin
* referrals, as a full copy so Demo can diverge without editing Skylight or HHB.
*
* The insurance-modal dropdown is derived from `payors`, so a payor staff can
* pick is by construction one this config knows about. It used to be handed
* HHB's Texas list by mistake.
*
* No payor carries `priorAuth`: Demo cannot file one, and its jobs are faked by
* `demoFeatures`. The gates skip a faked job rather than reading this, so the
* flag would be a claim about a capability that does not exist.
*/
const demoClinicConfig = buildClinicConfig({
	payors: [
		{
			payor: "BCBSTX",
			availityName: "BCBSTX"
		},
		{
			payor: "BCBSAZ",
			availityName: "BCBSAZ"
		},
		{
			payor: "Humana",
			availityName: "Humana"
		},
		{
			payor: "Aetna",
			availityName: "Aetna"
		},
		{
			payor: "HealthSpring",
			availityName: "HealthSpring"
		},
		{
			payor: "AZCompleteHealth",
			availityName: "Arizona Complete Health"
		},
		{ payor: "DemoHealth" },
		{ payor: "Medicare" }
	],
	athenaPayorMappings: {},
	azaleaPayorMappings: {},
	insuranceGroupToInfoMapping: {}
});

//#endregion
export { demoClinicConfig };